import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, styled, Typography } from '@mui/material';

export const ContactsContainerStyled = styled(Box)(({ theme }) => ({
  maxWidth: '150px',
  display: 'flex',
  flexDirection: 'column',
  [theme.breakpoints.up('lg')]: {
    marginLeft: '120px',
  },
}));

export const ContactsStyled = styled(Typography)(({ theme }) => ({
  fontSize: 14,
  fontWeight: 'bold',
  textTransform: 'uppercase',
  color: theme.palette.colors.onFooterBackground,
  marginBottom: '16px',
  [theme.breakpoints.up('sm')]: {
    marginBottom: '20px',
  },
}));

export const TypographyStyled = styled(Typography)(({ theme }) => ({
  fontSize: 12,
  fontWeight: theme.typography.fontWeightMedium,
  color: theme.palette.colors.onFooterBackground,
  '&#hemeraPhoneNumber': {
    marginBottom: '16px',

    [theme.breakpoints.up('sm')]: {
      marginBottom: '29px',
    },
  },
}));

export const FontAwesomeIconStyled = styled(FontAwesomeIcon)(({ theme }) => ({
  color: theme.palette.colors.iconsOnFooterBackground,
  fontSize: 16,
  marginRight: 8,
}));

export const InfoContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
}));
